import React__default from 'react';
import classnames from 'classnames';
import { Price } from '@grandvisionhq/common';

const Prices = ({ className , currency , discount , labels , orientation ='vertical' , originalPrice , totalPrice  })=>/*#__PURE__*/ React__default.createElement("div", {
        className: classnames('line-item__prices', {
            [`line-item__prices--${orientation}`]: discount > 0
        }, className)
    }, originalPrice !== 0 ? /*#__PURE__*/ React__default.createElement(Price, {
        value: originalPrice,
        currency: currency,
        className: classnames({
            'line-item__prices-discount-amount': discount > 0
        }),
        type: discount > 0 ? 'strikethrough' : 'default'
    }) : labels.freeProduct, discount > 0 && /*#__PURE__*/ React__default.createElement(Price, {
        value: totalPrice,
        currency: currency,
        type: "discount",
        size: "custom"
    }))
;

export { Prices };
//# sourceMappingURL=Prices.js.map
